import { render } from "./locations.vue?vue&type=template&id=59bf9bfc&scoped=true"
import script from "./locations.vue?vue&type=script&lang=js"
export * from "./locations.vue?vue&type=script&lang=js"

import "./locations.vue?vue&type=style&index=0&id=59bf9bfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bf9bfc"]])

export default __exports__